import { render, staticRenderFns } from "./search-by-cabin.vue?vue&type=template&id=04966ba3"
import script from "./search-by-cabin.vue?vue&type=script&lang=js"
export * from "./search-by-cabin.vue?vue&type=script&lang=js"
import style0 from "./search-by-cabin.vue?vue&type=style&index=0&id=04966ba3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports